var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoundationIconsVehiclesTruckTruckMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "9dpumsqava",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#9dpumsqava)",
    transform: "translate(-598.000000, -642.000000) translate(210.000000, 112.000000) translate(40.000000, 126.000000) translate(0.000000, 154.000000) translate(4.000000, 234.000000) translate(320.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.466,
    transform: "translate(24.000000, 16.000000) translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) translate(1.000000, 4.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07 13.5V3H2.694C1.104 3.117-.095 4.523.006 6.15v6.3c-.034.542.366 1.011.896 1.05h2.036"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.405,
    cy: 13.5,
    rx: 1.466,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.135,
    cy: 13.5,
    rx: 1.466,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.006 7.5h4.277c.465.007.847-.372.855-.848V3M5.871 13.5L14.669 13.5M.006 10.5L1.919 10.5M22 9H8.07V1.5c0-.828.657-1.5 1.467-1.5h10.997C21.344 0 22 .672 22 1.5V9zM17.601 13.5h2.933c.81 0 1.466-.672 1.466-1.5V9"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundationIconsVehiclesTruckTruckMd);
export default __webpack_public_path__ + "static/media/foundation-icons-vehicles-truck-truck-md.68441675.svg";
export { ForwardRef as ReactComponent };